import React from 'react';
import { RSVP } from '../types.ts';
import { EVENT_TITLE } from '../constants.ts';

interface ThankYouPageProps {
  rsvpData: RSVP;
  onGoBackToForm: () => void;
}

export const ThankYouPage: React.FC<ThankYouPageProps> = ({ rsvpData, onGoBackToForm }) => {
  return (
    <div className="p-4 md:p-8 bg-primary-bg rounded-lg font-montserrat w-full text-center">
      <h2 className="text-4xl font-playfair font-bold text-accent-gold mb-6">Thank You, {rsvpData.name}!</h2>
      <p className="text-xl text-text-white mb-8">Your RSVP for the {EVENT_TITLE} has been successfully submitted.</p>

      <div className="bg-primary-bg border border-accent-gold p-6 rounded-lg shadow-gold-lg mx-auto max-w-md">
        <h3 className="text-2xl font-playfair font-semibold text-accent-gold mb-4">Your Submission Details:</h3>
        <p className="text-lg text-text-white mb-2">
          <strong>Name:</strong> {rsvpData.name}
        </p>
        <p className="text-lg text-text-white mb-2">
          <strong>Attending:</strong>{' '}
          <span className={`px-2 py-1 rounded-full text-sm font-semibold ${rsvpData.attending ? 'bg-green-700 text-white' : 'bg-red-700 text-white'}`}>
            {rsvpData.attending ? 'Yes' : 'No'}
          </span>
        </p>
        {rsvpData.attending && (
          <p className="text-lg text-text-white mb-2">
            <strong>Dietary Preference:</strong> {rsvpData.dietaryPreference}
          </p>
        )}

        {rsvpData.attending && (
          <>
            <hr className="border-accent-gold my-6" />
            <h3 className="text-2xl font-playfair font-semibold text-accent-gold mb-4">✨ Important Information for Your Attendance ✨</h3>
            <p className="text-lg text-text-white mb-2 text-left">
              <strong>Dress Code:</strong> Glamour – we look forward to an evening full of sparkle and elegance.
            </p>
            <p className="text-lg text-text-white mb-2 text-left">
              <strong>Secret Santa:</strong> Please bring a neutral, wrapped gift worth up to €5 to activate our Secret Santa experience.
            </p>
            <p className="text-lg text-text-white mt-4 text-center">
              We can’t wait to celebrate the holiday season with you! 🎄✨
            </p>
          </>
        )}
      </div>

      <button
        onClick={onGoBackToForm}
        className="mt-10 inline-flex items-center px-8 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-primary-bg bg-accent-gold hover:bg-opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent-gold transition duration-300 ease-in-out"
      >
        Submit Another RSVP
      </button>

      <p className="text-base text-text-white leading-relaxed mt-12" aria-label="Closing message">We look forward to celebrating with you!</p>
    </div>
  );
};